import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-neutral-900 text-white" data-id="element-116">
      {/* Background Image Overlay */}{' '}
      <div className="absolute inset-0 z-0" data-id="element-117">
        <img src="https://cdn.magicpatterns.com/uploads/3UQsGTmEenZX33stLMmpYb/Teen-NTA.jpg" alt="Martial Arts Training" className="w-full h-full object-cover object-top opacity-40" data-id="element-118" />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/60 to-transparent" data-id="element-119" />
      </div>
      <div className="relative z-10 container mx-auto px-4 py-20 text-center max-w-5xl" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-121">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight tracking-tight" data-id="element-122">
            Taekwondo Classes for Kids, Teens, and Adults in{' '}
            <span className="text-red-600" data-id="element-123">Grapevine, Texas</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-124">
          <p className="text-xl md:text-2xl font-medium text-gray-200 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-125">
            Build confidence, discipline, and real-world self-defense in a
            positive, high-energy Taekwondo school focused on personal growth
            and results.
          </p>
          <p className="text-lg text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-126">
            Our Taekwondo programs help students of all ages improve focus,
            fitness, confidence, and mental toughness — all within a supportive
            and structured environment.
          </p>{' '}
          <Button className="text-xl px-10 py-5" href="/signup" data-id="element-127">
            GET STARTED TODAY
          </Button>
        </motion.div>
      </div>
    </section>;
}